import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const PatchObjectsButtonV2Widget: WidgetRegistryEntry = {
  name: "PatchObjectsButtonV2",
  component: () =>
    import("./patch-objects-button-widget-v2.component").then((module) => module.PatchObjectsButtonWidgetV2Component),
  configuration: () => import("./configuration").then((module) => module.PatchObjectsButtonWidgetV2Configuration)
};
